import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useWorldPresenceMutation, useWorldQuery } from '../api/endpoints/world'

/** Visible outdoor screens report presence; the server owns encounter timing. */
export function useWorldPresence(battleId: string | null) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { data: world } = useWorldQuery()
  const [presence] = useWorldPresenceMutation()
  const running = useRef(false)
  const outdoors = (pathname === '/play' || pathname === '/play/map') && !!world && !world.place_id && !world.travel && !world.activity && !world.encounter && !world.in_combat && !battleId
  useEffect(() => {
    if (!outdoors) return
    let alive = true
    const tick = async () => {
      if (!alive || document.visibilityState !== 'visible' || running.current) return
      running.current = true
      try {
        const result = await presence().unwrap()
        // A committed battle must be followed even if the screen changed in flight.
        if (result.battle_id) navigate(`/play/battle/${result.battle_id}`)
      } catch {
        // No client-side retries or catch-up. The next visible tick has a fresh id.
      } finally { running.current = false }
    }
    void tick()
    const interval = window.setInterval(() => void tick(), 20_000)
    const visible = () => { void tick() }
    document.addEventListener('visibilitychange', visible)
    return () => {
      alive = false
      window.clearInterval(interval)
      document.removeEventListener('visibilitychange', visible)
    }
  }, [outdoors, presence, navigate])
}
